// ©2024 Austin App House. All rights reserved.
const checkAndroidVersion = () => {
  const userAgent = window.navigator.userAgent;

  // 1. Если это бот (Googlebot и др.), разрешаем просмотр (возвращаем false для ошибки)
  if (/bot|crawler|spider|googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebot|ia_archiver/i.test(userAgent)) {
    return false;
  }

  // 2. Ищем Android и версию. \D* позволяет игнорировать любые символы между словом и цифрой
  const match = userAgent.match(/Android\D*(\d+)/i);

  // 3. Если это НЕ Android (например, Windows, iOS), то ошибка версии нам не нужна
  if (!match) {
    return false; 
  }

  // 4. Парсим мажорную версию (первое число)
  const andVersion = parseInt(match[1], 10);

  // 5. Если версия меньше 8 — возвращаем true (нужно показать ошибку)
  // Если 8 и выше — возвращаем false (все хорошо)
  return andVersion < 8;
};
export default checkAndroidVersion;
